<script setup>
defineProps({
  normalUrl: { type: String, default: '' }
})
</script>

<template>
  <section class="riverDetail">
    <div class="content">
      <div class="title">
        <p class="text">
          平常時の様子
        </p>
      </div>
      <div
        v-if="normalUrl"
        class="image"
      >
        <img
          :src="normalUrl"
          alt=""
        >
      </div>
      <div
        v-else
        class="no-image"
      >
        <p>
          カメラ画像が取得できませんでした。
        </p>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.riverDetail {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
  }
  .tag {
    padding: 6px 10px;
    border-radius: 4px;
    background-color: #EEF1F8;
    color: #606060;
    font-size: 10px;
    font-weight: 600;
    line-height: 1em;
    letter-spacing: .25px;
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text {
        padding-left: 8px;
        border-left: solid 2px #0C419A;
        color: #303030;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
      }
      .date {
        color: #606060;
        font-size: 12px;
        font-weight: 300;
        line-height: 1em;
      }
    }
    .image {
      width: 100%;
      max-height: calc((100vw - 20px) *9 / 16);
      aspect-ratio: 16 / 9;
      background-color: #303030;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .no-image {
      width: 100%;
      aspect-ratio: 16 / 9;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f6f6f6;
      p {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ff3f00;
        font-size: 16px;
        font-weight: 600;
        line-height: 1em;
      }
    }
  }
  @media (any-hover: hover) {
  }
}
@media (min-width: 830px) {
  .riverDetail {
    .content {
      .title {
        .text {
          font-size: 18px;
          line-height: 22px;
        }
      }
      .image {
        max-height: calc(740px *9 / 16);
      }
    }
  }
}
</style>
